import { Route } from '/@/modules/core/app/constants/api.constants';
import { ConnectedFinancialInstitution } from '/@/modules/financialaccount/models/ConnectedFinancialInstitution';
import { FinancialInstitutionResource } from '/@/modules/financialaccount/resources/FinancialInstitutionResource';
import { BaseResourceService } from '/@/modules/core/app/services/abstracts/BaseResourceService';
import { commits, getters } from '/@/modules/core/app/helpers/store';

export class ConnectedInstitutionsService extends BaseResourceService {
  /**
   * @var {GenericEntityResource|FinancialInstitutionResource}
   */
  resource;

  constructor() {
    super();
    this.resource = new FinancialInstitutionResource();
  }

  getRoute() {
    return Route.FINANCIAL_ACCOUNTS_CONNECTED_INSTITUTIONS;
  }

  getModel() {
    return ConnectedFinancialInstitution;
  }

  /**
   * @returns {?Promise<ConnectedFinancialInstitution[]>}
   */
  async getConnectedInstitutions() {
    const promise = getters.financialaccount.getConnectedPromise();

    if (promise?.pending) {
      return promise;
    }

    commits.financialaccount.setConnectedPromise(
      this.resource.getConnectedInstitutions()
      // new TaskPromise(this.resource.getConnectedInstitutions())
    );

    const connectedFinancialInstitutions = await getters.financialaccount.getConnectedPromise();
    commits.financialaccount.setConnectedFinancialInstitutions(connectedFinancialInstitutions);

    return connectedFinancialInstitutions;
  }
}

export default new ConnectedInstitutionsService();
